import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import CtaBlock, { CtaBlockType } from '../components/common/cta-block';
import Team, { TeamType } from '../components/who-we-are/team';

export const WhoWeArePage = ({ children, topCtaBlock, bottomCtaBlock, team }) => (
  <section>
    {children}

    <CtaBlock {...topCtaBlock} />

    <Team {...team} />

    <CtaBlock {...bottomCtaBlock} />
  </section>
);
WhoWeArePage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  topCtaBlock: CtaBlockType,
  bottomCtaBlock: CtaBlockType,
  team: TeamType,
};
WhoWeArePage.defaultProps = {
  children: undefined,
  topCtaBlock: {},
  bottomCtaBlock: {},
  team: {},
};

const WhoWeArePageTemplateWrapper = ({ data: { pageConfig: { title, topCtaBlock, bottomCtaBlock, team } } }) => (
  <WhoWeArePage topCtaBlock={topCtaBlock} bottomCtaBlock={bottomCtaBlock} team={team}>
    <Helmet title={title} />
  </WhoWeArePage>
);
WhoWeArePageTemplateWrapper.propTypes = {
  data: PropTypes.shape({
    pageConfig: PropTypes.shape({
      title: PropTypes.string,
      topCtaBlock: CtaBlockType,
      bottomCtaBlock: CtaBlockType,
      team: TeamType,
    }).isRequired,
  }).isRequired,
};
export default WhoWeArePageTemplateWrapper;

export const pageQuery = graphql`
  query WhoWeArePageQuery($path: String!) {
    pageConfig: pagesYaml(path: { eq: $path }) {
      id
      title
      topCtaBlock {
        hasImage
        isDark
        hasButton
        image
        headText
        subText
        linkText
        linkUrl
      }
      bottomCtaBlock {
        hasImage
        isDark
        hasButton
        image
        headText
        subText
        linkText
        linkUrl
      }
      team {
        title
        items {
          name
          title
          description
          image
          social {
            type
            url
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/who-we-are-page.jsx